import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { InformationCircleIcon } from '@heroicons/react/outline';

export default function SafetyNorms() {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { extension: { eq: "pdf" } }) {
        edges {
          node {
            publicURL
            name
          }
        }
      }
    }
  `);
  const [pdf] = data.allFile.edges.filter(
    ({ node }) => node.name === 'Bioseguridad-COVID-19-SVRID'
  );
  return (
    <div className="w-11/12 mx-auto h-auto flex flex-row flex-wrap mb-4 -mt-10 relative z-10 md:w-full">
      <div className="max-w-4xl w-full pr-8 py-3 mx-auto bg-blue-700 text-white font-semibold rounded-lg shadow-2xl flex flex-wrap flex-row">
        <div className="hidden md:flex w-8 h-8 text-white ml-4 mr-1">
          <InformationCircleIcon className="text-white m-auto h-4 w-4" />
        </div>
        <a className="px-4 md:px-0 my-auto" href={pdf.node.publicURL} download>
          Respuesta al COVID-19: Revisa las Normas de Bioseguridad
        </a>
      </div>
    </div>
  );
}
